// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { analyticsAllowed } from "./lib/cookieConsent";

// Your web app's Firebase configuration
// Note: These values are loaded from environment variables
// For Create React App, environment variables must be prefixed with REACT_APP_
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "",
};

// Validate that all required environment variables are set
if (!firebaseConfig.apiKey || !firebaseConfig.projectId) {
  console.error('Missing required Firebase configuration. Please check your .env file.');
  throw new Error('Firebase configuration is incomplete. Check environment variables.');
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

let analytics = null;

/**
 * Initialize Firebase Analytics only when the user has accepted analytics cookies.
 */
export async function initAnalyticsIfConsented() {
  if (!analyticsAllowed()) return null;
  if (analytics) return analytics;
  if (!firebaseConfig.measurementId) return null;
  try {
    const supported = await isSupported();
    if (!supported) return null;
    analytics = getAnalytics(app);
    return analytics;
  } catch (e) {
    console.warn('Firebase Analytics could not be initialized', e);
    return null;
  }
}

export { app, analytics, auth };
